/**
 * Series palettes for Highcharts. Series colors are defined in highcharts.scss.
 * **Do not edit this file!** This file is generated using the 'gulp palette' task.
 */
var SeriesPalettes = {
    /**
     * Colors for data series and points.
     */
    colors: [
        '#7cb5ec',
        '#434348',
        '#90ed7d',
        '#f7a35c',
        '#8085e9',
        '#f15c80',
        '#e4d354',
        '#2b908f',
        '#f45b5b',
        '#91e8e1'
    ]
};
export default SeriesPalettes;
